import { Injector, Component, OnInit } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { isEmpty } from 'lodash';
import { LinkExpirationServie } from '../../../Services/link-expiration/link-expiration';
import * as bowser from 'bowser';
import { find } from 'lodash';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'secondary-online-buy',
	template: `
		<div *ngIf="this.shouldShowSecond" class="buy clearfix" [ngClass]="{ 'design-update-test-c': coveragesTestC }">
			<div class="content" [ngSwitch]="selectedOption.type" [ngClass]="selectedOption.type">
				<div *ngSwitchCase="'buyOnline'" id="curentQuote">
					<div class="sur">
						<analyzed-element>
							<h2
								[ngClass]="{
									testB: control && control.attributes && control.attributes.testB,
									'call-now-title': shouldShowCallMeNow,
									'call-paa-mobile': shouldShowCallPaa
								}"
							>
								{{
									(this.finishButtonToCustomizeFlag && !shouldShowCallPaa)
										? 'Tailor coverage to your needs'
										: shouldShowCallPaa
										? this.control.attributes.callPAABox.title
										: 'Buy this policy!'
								}}
							</h2>
							<!-- dont forget to add phone icone -->
							<div *ngIf="shouldShowCallPaa" class="call-paa">
								<img class="phone-icone" src="../../../../assets/images/icons/phone-icon.svg" classname="img-fluid" />
								<a [href]="dialNumber">{{ dialNumber.replace('tel:', '') }}</a>
							</div>
						</analyzed-element>
						<div>
							<button
								[ngClass]="{ disabled: this.control.disabled, 'requote-button-call-now': shouldShowCallMeNow }"
								class="requote-button {{ selectedOption.buyButton.attributes.buttonPosition }} {{
									selectedOption.buyButton.attributes.type
								}}"
								gtm-handler
								events="click"
								handlerType="button"
								label="Buy_Online_Button_Bottom"
								action="ButtonClick"
								(click)="buyClicked()"
							>
								<span class="button-label desktop">
									{{
										(this.finishButtonToCustomizeFlag && !shouldShowCallPaa)
											? 'Customize and buy'
											: selectedOption.buyButton.attributes.label
									}}
								</span>
								<span class="button-label mobile">{{ setMobileLabel() }}</span>
							</button>
							<br />
							<br />
						</div>
						<p class="online-pohone" *ngIf="!shouldShowCallMeNow && !shouldShowCallPaa">
							or call an expert at
							<a *ngIf="!bowser.mobile" tabindex="0" class="phone" (keydown.enter)="phoneClick()">
								<span tabindex="-1" [innerHtml]="selectedOption.phoneNum" (click)="phoneClick()"> </span>
							</a>
							<a
								*ngIf="bowser.mobile"
								class="phone"
								[href]="dialNumber"
								gtm-handler
								events="click"
								handlerType="dataValue"
								label="Call_Progressive"
								value="{{ dialNumber.replace('tel:', '') }}"
								action="LinkClick"
								[innerHtml]="selectedOption.phoneNum"
								(click)="phoneClick()"
							></a>
						</p>
						<div class="call-me-now-wrapper" *ngIf="shouldShowCallMeNow">
							<p class="call-me-now-first-row">Or, we have experts standing by</p>
							<p class="call-me-now-second-row">Quote Number: {{ selectedOption.quoteNum }}</p>
							<div class="call-me-now-btn-wrapper">
								<a
									[href]="dialNumber"
									class="phoneBtn"
									action="LinkClick"
									[innerHtml]="selectedOption.phoneNum"
									(click)="callNowphoneClick()"
								></a>
								<a class="callMeNowBtn" action="LinkClick" (click)="callMeNowClick()">Call me now</a>
								<app-popup name="Popup.TalkWithUsBottom"></app-popup>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./secondary-online-buy.component.scss'],
})
export class SecondaryOnlineBuyComponent extends EventsComponent implements OnInit {
	comparisonSectionVisible: boolean = false;
	OnlineBuyActive: boolean = false;
	shouldShowSecond: boolean = false;
	shouldShowCallMeNow: boolean = false;
	finishButtonToCustomizeFlag: boolean = false;
	coveragesTestC: boolean = false;
	optionType: any;
	selectedOption: any;
	dialNumber: any;
	bowser: any;
	isCovModFlagOn: boolean;
	isAgentFlowType: boolean;
	isCallPAAFlagOn: boolean;
	shouldShowCallPaa: boolean = false;

	constructor(
		injector: Injector,
		private LayoutService: LayoutService,
		private actionApiService: ActionApiService,
		private linkExpiration: LinkExpirationServie
	) {
		super(injector);
	}

	ngOnInit() {
		this.selectedOption = this.getSelection();
		this.optionType = this.selectedOption.type;
		this.bowser = bowser;
		this.shouldShow();
		if (this.selectedOption && this.selectedOption.buyButton) {
			this.linkExpiration.setLinkExpiration(this.selectedOption.buyButton.attributes.ReQuotedData);
		}
		this.layoutService.globalAttributes.subscribe((data) => {
			this.shouldShowCallMeNow = data['shouldShowCallMeNow'];
			this.finishButtonToCustomizeFlag = data['finishButtonToCustomize'];
			this.coveragesTestC =
				this.control.attributes && this.control.attributes.isSingleRateDesignChange && data['showInfoBlocks'];
			this.isCovModFlagOn = data['covModFlag'];
			this.isAgentFlowType = data['flowType'] == 'Agent';
			this.isCallPAAFlagOn = data['call-paa-message-pilot'];
			this.shouldShowCallPaa = this.shouldShowCallPAA();
		});

		this.observablesService.insurerSelected.subscribe(() => {
			this.selectedOption = this.getSelection();
			if (this.selectedOption && this.selectedOption.buyButton) {
				this.linkExpiration.setLinkExpiration(this.selectedOption.buyButton.attributes.ReQuotedData);
			}
			this.shouldShow();
		});

		this.observablesService.ComparisonSectionVisible.subscribe((res) => {
			this.comparisonSectionVisible = res;
			this.shouldShow();
		});
	}

	callNowphoneClick() {}

	callMeNowClick() {
		let carrierInfo = this.storeService.getValue('CarrierInformation', this.context);
		const newObject = {};
		Object.keys(carrierInfo).forEach((oldKey) => {
			delete Object.assign(newObject, carrierInfo, { ['CarrierInformation.' + oldKey]: newObject[oldKey] })[oldKey];
		});
		const requestBody: request = {
			data: newObject,
			info: {
				action: 'TalkWithUs',
				conditions: '',
				elementSrc: 'show_bottom',
				stage: 'Enter_Phone_1',
				notRenderPage: false,
			},
			isRemoteAction: true,
		};
		this.actionApiService.invokeAction(requestBody);
	}

	shouldShow() {
		this.optionType = this.selectedOption.type;
		this.shouldShowSecond = this.optionType == 'buyOnline';

		var elem = this.elementRef.nativeElement.parentElement.parentElement;
		if (this.shouldShowSecond) {
			this.Renderer.setStyle(elem, 'display', 'block');
		} else {
			this.Renderer.setStyle(elem, 'display', 'none');
		}
		setTimeout(() => {
			this.observablesService.OnlineBuyActive.next(this.shouldShowSecond);
		}, 0);
		return this.shouldShowSecond;
	}
	get yearly() {
		return this.selectedOption && this.selectedOption.year.split('.');
	}

	getSelection() {
		this.dialNumber = 'tel:' + this.control.attributes.phoneNum;
		let selected = this.storeService.getValue('CarrierInformation', this.context);
		return find(this.control.attributes.options, { name: selected.name });
	}

	setHref() {
		let selected = this.storeService.getValue('CarrierInformation', this.context);

		return this.control.disabled
			? ''
			: !isEmpty(selected.buyButtonUrl)
			? selected.buyButtonUrl
			: !isEmpty(this.selectedOption.buyButton.attributes.url)
			? this.selectedOption.buyButton.attributes.url
			: '';
	}

	hasUrl() {
		return !isEmpty(this.selectedOption.buyButton.attributes.url);
	}

	setMobileLabel() {
		return !isEmpty(this.selectedOption.buyButton.attributes.mobilelabel)
			? this.selectedOption.buyButton.attributes.mobilelabel
			: this.selectedOption.buyButton.attributes.label;
	}

	buyButtonClick() {
		if (
			!this.linkExpiration.validateLinkExpiration(
				this.selectedOption.buyButton.ajaxInfo,
				this.selectedOption.buyButton.attributes.ReQuotedData
			)
		) {
			this.selectedOption.buyButton.attributes.url = '';
		}
		this.control.ajaxInfo = this.selectedOption.buyButton.ajaxInfo;
		this.value = this.storeService.getValue('CarrierInformation', this.context);
		this.actionService.ajaxAction(this.control.ajaxInfo, this.context);
	}

	buyClicked() {
		let location = this.control.disabled ? '' : this.setHref();
		!this.control.disabled &&
			(!this.hasUrl() || this.selectedOption.buyButton.attributes.mixaction) &&
			this.buyButtonClick();
		location = this.control.disabled ? '' : this.setHref();
		// FIX for safari wait until ajaxAction finished
		// this.observablesService.preBridgeCall = new Subject<any>();
		this.observablesService.preBridgeCall.subscribe(() => {
			!isEmpty(location) && window.open(location, '_self');
		});
	}

	isMObile() {
		return bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile';
	}

	phoneClick() {}

	shouldShowCallPAA() {
		return this.isCallPAAFlagOn && this.control.attributes.callPAABox && !this.isCovModFlagOn && !this.isAgentFlowType;
	}
}
